import React, { useState, useEffect } from "react";
import { Card, Badge, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";
import {
  BrokerPi42wallet,
  Pi42Positions,
  Pi42TransactionHistory,
  UserDirectExit,
} from "../../../Service/Broker.service.jsx";
import Swal from "sweetalert2";

const Pi42Wallet = () => {
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const UserNamego_localstg = JSON.parse(
    localStorage.getItem("user_details_goTo")
  );
  const [walletdata, setWalletdata] = useState({});
  const [positiondata, setPositiondata] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState({
    wallet: false,
    positions: false,
    transactions: false,
    exit: false,
  });

  useEffect(() => {
    if (gotodashboard ? UserNamego_localstg.user_id : user_details?.user_id) {
      getWallet();
      getPositions();
      getTransactions();
    } else {
      Swal.fire({
        icon: "warning",
        title: "User Not Found",
        text: "Please login again to access wallet data.",
      });
    }
  }, []);

  const getWallet = async () => {
    try {
      setLoading((prev) => ({ ...prev, wallet: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id,
      };
      const response = await BrokerPi42wallet(data);
   

      if (response?.status) {
        setWalletdata(response?.data || {});
      } else {
        setWalletdata({});
      }
    } catch (error) {
      console.error("Wallet Error:", error);
      setWalletdata({});
    } finally {
      setLoading((prev) => ({ ...prev, wallet: false }));
    }
  };

  const getPositions = async () => {
    try {
      setLoading((prev) => ({ ...prev, positions: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id
      };
      const response = await Pi42Positions(data);

      if (response.status) {
        setPositiondata(response?.data || []);
      } else {
        setPositiondata([]);
      }
    } catch (error) {
      console.error("Positions Error:", error);
      setPositiondata([]);
    } finally {
      setLoading((prev) => ({ ...prev, positions: false }));
    }
  };

  const getTransactions = async () => {
    try {
      setLoading((prev) => ({ ...prev, transactions: true }));
      const data = {
        userid: gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id
      };
      const response = await Pi42TransactionHistory(data);

      if (response.status) {
        setTransactions(response?.data || []);
      } else {
        setTransactions([]);
      }
    } catch (error) {
      console.error("Transactions Error:", error);
      setTransactions([]);
    } finally {
      setLoading((prev) => ({ ...prev, transactions: false }));
    }
  };

  const LoadingSpinner = () => (
    <div className="d-flex justify-content-center align-items-center py-4">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );

  // Handle Direct Exit from broker
  const handleDirectExit = async (position) => {
    const result = await Swal.fire({
      title: "Exit Position?",
      text: `Are you sure you want to exit ${position.contractPair} ${position.positionType} position?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Exit!",
    });

    if (result.isConfirmed) {
      try {
        setLoading((prev) => ({ ...prev, exit: true }));
        const userId = gotodashboard
          ? UserNamego_localstg.user_id
          : user_details?.user_id;
        const token = gotodashboard
          ? UserNamego_localstg.token
          : user_details?.token;

        const data = {
          user_id: userId,
          symbol: position.contractPair,
          trade_side: position.positionType === "LONG" ? "LX" : "SX",
          // price: position.entryPrice, // Comment out for MARKET order
          quantity: position.positionAmount,
          broker: "pi42",
        };

        const response = await UserDirectExit(data, token);

        if (response?.status) {
          Swal.fire({
            icon: "success",
            title: "Exit Successful",
            text: response?.message || "Position exited successfully from broker!",
          });
          // Wait 3 seconds for broker to process exit, then refresh positions
          setTimeout(() => {
            getPositions();
          }, 3000);
        } else {
          Swal.fire({
            icon: "error",
            title: "Exit Failed",
            text: response?.message || "Failed to exit position",
          });
        }
      } catch (error) {
        console.error("Error exiting position:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Something went wrong while exiting position",
        });
      } finally {
        setLoading((prev) => ({ ...prev, exit: false }));
      }
    }
  };

  // Positions DataTable Columns
  const positionsColumns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "60px",
      cell: (row, index) => (
        <span
          className="badge text-dark"
          style={{
            borderRadius: "8px",
            padding: "6px 10px",
          }}
        >
          {index + 1}
        </span>
      ),
    },
    {
      name: "Contract Pair",
      selector: (row) => row.contractPair,
      sortable: true,
      cell: (row) => (
        <div className="d-flex align-items-center">
          {row?.iconUrl && (
            <img
              src={row.iconUrl}
              alt={row.baseAsset}
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "50%",
                marginRight: "10px",
                border: "2px solid #2196f3",
              }}
            />
          )}
          <div>
            <div className="fw-bold text-primary">{row?.contractPair}</div>
            <small className="text-muted">
              {row?.baseAsset}/{row?.quoteAsset}
            </small>
          </div>
        </div>
      ),
      width: "200px",
    },
    {
      name: "Position Type",
      selector: (row) => row.positionType,
      sortable: true,
      cell: (row) => (
        <div>
          <Badge
            bg={row?.positionType === "LONG" ? "success" : "danger"}
            style={{
              borderRadius: "20px",
              padding: "8px 16px",
            }}
          >
            {row?.positionType === "LONG" ? "📈 Long" : "📉 Short"}
          </Badge>
          <div className="mt-1">
            <Badge
              bg="secondary"
              style={{
                borderRadius: "20px",
                padding: "4px 8px",
                fontSize: "10px",
              }}
            >
              {row?.marginType}
            </Badge>
          </div>
        </div>
      ),
    },
    {
      name: "Entry Price",
      selector: (row) => parseFloat(row.entryPrice),
      sortable: true,
      cell: (row) => (
        <span className="fw-bold">
          ${parseFloat(row?.entryPrice).toFixed(5)}
        </span>
      ),
    },
    {
      name: "Position Amount",
      selector: (row) => parseFloat(row.positionAmount),
      sortable: true,
      cell: (row) => (
        <div>
          <div className="fw-bold">
            {parseFloat(row?.positionAmount).toFixed(2)}
          </div>
          <small className="text-muted">
            Size: ${parseFloat(row?.positionSize).toFixed(2)}
          </small>
        </div>
      ),
    },
    {
      name: "Leverage",
      selector: (row) => row.leverage,
      sortable: true,
      cell: (row) => (
        <Badge
          bg="info"
          style={{
            borderRadius: "20px",
            padding: "8px 16px",
          }}
        >
          {row?.leverage}x
        </Badge>
      ),
    },
    {
      name: "Margin",
      selector: (row) => parseFloat(row.margin),
      sortable: true,
      cell: (row) => (
        <div>
          <div className="fw-bold">{parseFloat(row?.margin).toFixed(4)}</div>
          <small className="text-muted">
            ₹{parseFloat(row?.marginInMarginAsset).toFixed(2)}
          </small>
        </div>
      ),
    },
    {
      name: "Liquidation Price",
      selector: (row) => parseFloat(row.liquidationPrice),
      sortable: true,
      cell: (row) => (
        <span className="text-danger fw-bold">
          ${parseFloat(row?.liquidationPrice).toFixed(5)}
        </span>
      ),
    },
    {
      name: "Realized Profit",
      selector: (row) => parseFloat(row.realizedProfit || 0),
      sortable: true,
      cell: (row) => (
        <span
          className={
            parseFloat(row?.realizedProfit || 0) >= 0
              ? "text-success fw-bold"
              : "text-danger fw-bold"
          }
        >
          {parseFloat(row?.realizedProfit || 0) >= 0 ? "+" : ""}
          {parseFloat(row?.realizedProfit || 0).toFixed(2)}
        </span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <Button
          variant="danger"
          size="sm"
          onClick={() => handleDirectExit(row)}
          disabled={loading.exit}
          style={{
            borderRadius: "20px",
            padding: "6px 16px",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          {loading.exit ? (
            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          ) : (
            "🚪"
          )}
          Exit
        </Button>
      ),
    },
  ];

  // Transactions DataTable Columns
  const transactionsColumns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      width: "60px",
      cell: (row, index) => (
        <span
          className="badge text-dark"
          style={{
            borderRadius: "8px",
            padding: "6px 10px",
          }}
        >
          {index + 1}
        </span>
      ),
    },
    {
      name: "Trade ID",
      selector: (row) => row.tradeId,
      sortable: true,
      cell: (row) => (
        <span className="badge bg-light text-dark">#{row?.tradeId}</span>
      ),
    },
    {
      name: "Date & Time",
      selector: (row) => row.time,
      sortable: true,
      cell: (row) => (
        <div>
          <div className="fw-bold" style={{ color: "#2c3e50", fontSize: "14px" }}>
            {new Date(row?.time).toLocaleDateString()}
          </div>
          <small className="text-muted">
            {new Date(row?.time).toLocaleTimeString()}
          </small>
        </div>
      ),
      width: "150px",
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      cell: (row) => (
        <Badge
          bg={
            row?.type === "COMMISSION"
              ? "warning"
              : row?.type === "GST_ON_COMMISSION"
                ? "secondary"
                : "info"
          }
          style={{
            borderRadius: "20px",
            padding: "6px 12px",
            fontSize: "11px",
          }}
        >
          {row?.type.replace(/_/g, " ")}
        </Badge>
      ),
      width: "200px",
    },
    {
      name: "Symbol",
      selector: (row) => row.symbol,
      sortable: true,
      cell: (row) => (
        <div>
          <div className="fw-bold">{row?.symbol || "-"}</div>
          <small className="text-muted">
            {row?.baseAsset}/{row?.quoteAsset}
          </small>
        </div>
      ),
    },
    {
      name: "Contract Type",
      selector: (row) => row.contractType,
      sortable: true,
      cell: (row) => (
        <Badge
          bg="light"
          text="dark"
          style={{
            borderRadius: "20px",
            padding: "6px 12px",
          }}
        >
          {row?.contractType}
        </Badge>
      ),
    },
    {
      name: "Amount",
      selector: (row) => parseFloat(row.amount),
      sortable: true,
      cell: (row) => (
        <span
          className={
            parseFloat(row?.amount) >= 0
              ? "text-success fw-bold"
              : "text-danger fw-bold"
          }
          style={{ fontSize: "15px" }}
        >
          {parseFloat(row?.amount) >= 0 ? "+" : ""}
          {parseFloat(row?.amount).toFixed(2)}
        </span>
      ),
    },
    {
      name: "Asset",
      selector: (row) => row.asset,
      sortable: true,
      cell: (row) => (
        <Badge
          bg="primary"
          style={{
            borderRadius: "20px",
            padding: "8px 16px",
          }}
        >
          {row?.asset}
        </Badge>
      ),
    },
  ];

  // Custom styles for DataTable
  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #dee2e6",
        fontSize: "14px",
        fontWeight: "600",
        color: "#6c757d",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
        borderBottom: "1px solid #f0f0f0",
        "&:hover": {
          backgroundColor: "#f8f9fa",
          cursor: "pointer",
        },
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #dee2e6",
        fontSize: "13px",
      },
    },
  };

  return (
    <div>
      <div className="container-fluid p-0">
        {/* Header */}
        <div className="mb-4">
          <h5 className="fw-bold mb-1">🟣 Pi42 Wallet</h5>
          <p className="mb-0">Manage your Pi42 futures trading account</p>
        </div>

        <Card
          className="shadow-lg border-0"
          style={{ borderRadius: "20px", overflow: "hidden" }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              padding: "15px",
            }}
          >
            <div className="row">

              {/* ---- Card 1 ---- */}
              <div className="col-md-3 mb-3 wallet-col">
                <div
                  className="text-center p-4 h-100 wallet-card"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2 wallet-icon"
                      style={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span>💰</span>
                    </div>
                  </div>

                  <h6 className="text-white-50 mb-2">Wallet Balance</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <>
                      <h2 className="text-white fw-bold mb-1">
                        ₹{walletdata?.walletBalance || "0.00"}
                      </h2>
                      <small className="text-white-50">
                        {walletdata?.marginAsset || "INR"}
                      </small>
                    </>
                  )}
                </div>
              </div>

              {/* ---- Card 2 ---- */}
              <div className="col-md-3 mb-3 wallet-col">
                <div
                  className="text-center p-4 h-100 wallet-card"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2 wallet-icon"
                      style={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span>🔒</span>
                    </div>
                  </div>

                  <h6 className="text-white-50 mb-2">Locked Balance</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <>
                      <h2 className="text-white fw-bold mb-1">
                        ₹{walletdata?.lockedBalance || "0.00"}
                      </h2>
                      <small className="text-white-50">In positions</small>
                    </>
                  )}
                </div>
              </div>

              {/* ---- Card 3 ---- */}
              <div className="col-md-3 mb-3 wallet-col">
                <div
                  className="text-center p-4 h-100 wallet-card"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2 wallet-icon"
                      style={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span>💵</span>
                    </div>
                  </div>

                  <h6 className="text-white-50 mb-2">Margin Balance</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <>
                      <h2 className="text-white fw-bold mb-1">
                        ₹{walletdata?.marginBalance || "0.00"}
                      </h2>
                      <small className="text-white-50">Total margin</small>
                    </>
                  )}
                </div>
              </div>

              {/* ---- Card 4 ---- */}
              <div className="col-md-3 mb-3 wallet-col">
                <div
                  className="text-center p-4 h-100 wallet-card"
                  style={{
                    backgroundColor: "rgba(255,255,255,0.15)",
                    backdropFilter: "blur(10px)",
                    borderRadius: "15px",
                    border: "1px solid rgba(255,255,255,0.2)",
                  }}
                >
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center mb-2 wallet-icon"
                      style={{
                        backgroundColor: "rgba(255,255,255,0.2)",
                        borderRadius: "50%",
                      }}
                    >
                      <span>📊</span>
                    </div>
                  </div>

                  <h6 className="text-white-50 mb-2">Unrealised PnL (Isolated)</h6>
                  {loading.wallet ? (
                    <div className="text-white">Loading...</div>
                  ) : (
                    <>
                      <h2 className="text-white fw-bold mb-1">
                        ₹{walletdata?.unrealisedPnlIsolated || "0.00"}
                      </h2>
                      <small className="text-white-50">
                        {walletdata?.pnlPercentIsolated || "0.00"}%
                      </small>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>


          <div className="p-3">
            {/* Positions Section with DataTable */}
            <div className="mb-5">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#fff3e0",
                    borderRadius: "15px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>📊</span>
                </div>
                <div>
                  <h5 className="mb-1 fw-bold">Active Positions</h5>
                  <small>Your current trading positions</small>
                </div>
              </div>

              {loading.positions ? (
                <LoadingSpinner />
              ) : positiondata.length === 0 ? (
                <div
                  className="text-center py-5"
                  style={{ borderRadius: "15px" }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    📈
                  </div>
                  <p className="mb-0">No positions available.</p>
                </div>
              ) : (
                <div
                  style={{
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <DataTable
                    columns={positionsColumns}
                    data={positiondata}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    customStyles={customStyles}
                    highlightOnHover
                    striped
                    responsive
                  />
                </div>
              )}
            </div>

            {/* Transactions Section with DataTable */}
            <div className="mb-5">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#e3f2fd",
                    borderRadius: "15px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>🧾</span>
                </div>
                <div>
                  <h5 className="mb-1 fw-bold">Recent Transactions</h5>
                  <small>Your latest trading activity</small>
                </div>
              </div>

              {loading.transactions ? (
                <LoadingSpinner />
              ) : transactions?.length === 0 ? (
                <div
                  className="text-center py-5"
                  style={{ borderRadius: "15px" }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    💳
                  </div>
                  <p className="mb-0">No transactions available.</p>
                </div>
              ) : (
                <div
                  style={{
                    borderRadius: "15px",
                    overflow: "hidden",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <DataTable
                    columns={transactionsColumns}
                    data={transactions}
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[5, 10, 15, 20]}
                    customStyles={customStyles}
                    highlightOnHover
                    striped
                    responsive
                  />
                </div>
              )}
            </div>

            {/* Wallet Details Section */}
            <div className="mb-5">
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-inline-flex align-items-center justify-content-center me-3"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#f3e5f5",
                    borderRadius: "15px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>💳</span>
                </div>
                <div>
                  <h5 className="mb-1 fw-bold">Wallet Details</h5>
                  <small>Complete wallet information</small>
                </div>
              </div>

              {loading.wallet ? (
                <LoadingSpinner />
              ) : Object.keys(walletdata).length === 0 ? (
                <div
                  className="text-center py-5"
                  style={{ borderRadius: "15px" }}
                >
                  <div style={{ fontSize: "48px", marginBottom: "16px" }}>
                    📭
                  </div>
                  <p className="mb-0">No wallet data available.</p>
                </div>
              ) : (
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div
                      className="p-4"
                      style={{
                        borderRadius: "15px",
                        border: "1px solid #e0e0e0",
                        backgroundColor: "#fff",
                      }}
                    >
                      <table className="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td className="py-2">
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "10px",
                                  }}
                                >
                                  🚫
                                </span>
                                <strong>Maintenance Margin</strong>
                              </div>
                            </td>
                            <td className="py-2 text-end fw-bold text-warning">
                              ₹{walletdata?.maintenanceMargin || "0.00"}
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2">
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "10px",
                                  }}
                                >
                                  📈
                                </span>
                                <strong>Unrealised PnL (Cross)</strong>
                              </div>
                            </td>
                            <td className="py-2 text-end fw-bold">
                              <span
                                className={
                                  parseFloat(
                                    walletdata?.unrealisedPnlCross || 0
                                  ) >= 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                ₹{walletdata?.unrealisedPnlCross || "0.00"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2">
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "10px",
                                  }}
                                >
                                  📉
                                </span>
                                <strong>Unrealised PnL (Isolated)</strong>
                              </div>
                            </td>
                            <td className="py-2 text-end fw-bold">
                              <span
                                className={
                                  parseFloat(
                                    walletdata?.unrealisedPnlIsolated || 0
                                  ) >= 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                ₹{walletdata?.unrealisedPnlIsolated || "0.00"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2">
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "10px",
                                  }}
                                >
                                  📊
                                </span>
                                <strong>PnL Percent (Cross)</strong>
                              </div>
                            </td>
                            <td className="py-2 text-end fw-bold">
                              <span
                                className={
                                  parseFloat(
                                    walletdata?.pnlPercentCross || 0
                                  ) >= 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {walletdata?.pnlPercentCross || "0.00"}%
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2">
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "10px",
                                  }}
                                >
                                  📉
                                </span>
                                <strong>PnL Percent (Isolated)</strong>
                              </div>
                            </td>
                            <td className="py-2 text-end fw-bold">
                              <span
                                className={
                                  parseFloat(
                                    walletdata?.pnlPercentIsolated || 0
                                  ) >= 0
                                    ? "text-success"
                                    : "text-danger"
                                }
                              >
                                {walletdata?.pnlPercentIsolated || "0.00"}%
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="py-2">
                              <div className="d-flex align-items-center">
                                <span
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "10px",
                                  }}
                                >
                                  🏷️
                                </span>
                                <strong>Margin Asset</strong>
                              </div>
                            </td>
                            <td className="py-2 text-end">
                              <Badge
                                bg="primary"
                                style={{
                                  borderRadius: "20px",
                                  padding: "8px 16px",
                                }}
                              >
                                {walletdata?.marginAsset || "INR"}
                              </Badge>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Pi42Wallet;